<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (server of servers | async; track trackBy(server)) {
      <lcs-option [value]="server" id="lcs-option-id-{{ server.serverId }}">
         {{ server.serverName }}
      </lcs-option>
      }
   </div>
</ng-template>
